import {fork} from 'redux-saga/effects';
import validateAddress from './smartystreets';
import prequalAddress from './prequal';

export default function *sagas () {
    yield [
        fork(validateAddress),
        fork(prequalAddress)
    ];
}


// WEBPACK FOOTER //
// ./src/sagas/index.js